export default __webpack_public_path__ + "static/media/calendar.2c60903b.svg";